<template>
  <div>
    <v-container fluid class="py-0">
      <!--      <v-row>
              <v-card flat color="transparent" class="mx-auto py-6 text-center">
                <v-card-title class="display-1 mb-2">{{ $t("recruit.title") }}</v-card-title>
                <v-card-subtitle class="subtitle-1">RECRUIT</v-card-subtitle>
              </v-card>
            </v-row>-->
      <!--      <v-row no-gutters class="text-center" align="start">
              <v-spacer></v-spacer>
              <v-col :cols='isMobile?12:"false"'>
                <v-card class="mb-4" flat tile color="transparent">
                  <v-card-title :class='isMobile?"subtitle-1":"title font-weight-regular text-no-wrap justify-center"' v-html="$t('recruit.mainPage.content')">{{ $t('recruit.mainPage.content') }}</v-card-title>
                </v-card>
              </v-col>
              <v-spacer></v-spacer>
            </v-row>-->
      <!--      <v-row>
                <v-card flat color="transparent" class="mx-auto mt-2 mb-6 text-center">
                  <v-card-title class="font-weight-regular mb-2">{{ $t('recruit.mainPage.title1') }}</v-card-title>
                </v-card>
            </v-row>-->

      <!--      <tci-title :title="$t('recruit.title')" subtitle="RECRUIT"   class="font-weight-regular mb-2"></tci-title>-->
      <!--      非手机端 -->
      <v-row>
        <v-card flat color="transparent" class="mx-auto py-6 text-center">
          <v-card-title class="display-1 mb-2">{{ $t("recruit.title") }}</v-card-title>
          <v-card-subtitle class="subtitle-1">RECRUIT</v-card-subtitle>
        </v-card>
      </v-row>

      <v-spacer></v-spacer>
      <v-row  justify="center" class="d-none d-sm-flex">
        <!--<v-spacer class="d-none d-sm-flex"></v-spacer>-->
        <v-col  :cols='isMobile?12:"false"'
                md="7" >
          <v-img :aspect-ratio="16/9"   style="margin-left: 15%;height: 120%;border:1px solid #ccc"  src="../assets/recruit/1-1.jpg" >

          </v-img>


        </v-col>
        <v-col  :cols='isMobile?6:"false"'
                md="5">
          <v-img :aspect-ratio="21/9"  style="margin-right: 15%;height:60%;border:1px solid #ccc"  src="../assets/recruit/bg1.jpg"  >
          </v-img>
          <br>

          <v-img :aspect-ratio="3/2" style="display:inline-block;margin-right: 3%;height:55%;border:1px solid #ccc"  width="41%" src="../assets/recruit/bg2.jpg" >
          </v-img>

          <v-img :aspect-ratio="3/2"  style="display:inline-block;margin-right: 15%;height:55%;border:1px solid #ccc" width="41%" src="../assets/recruit/bg3.jpg" >
          </v-img>
        </v-col>
        <!--<v-spacer class="d-none d-sm-flex"></v-spacer> -->
      </v-row>


      <!--      手机端 -->
      <v-row justify="center" class="d-flex d-sm-none">
        <v-col v-for="(recruit,index) in recruits" :key="recruit.title" class="mx-0 px-0 py-1">
          <v-img height=200 :src="recruit.imageUrl" :position="index===3?'top left':'center center'">
            <v-row align="center" class="white--text fill-height text-center px-0 mx-0">
              <v-col>
                <v-card flat tile color="transparent" >
                  <v-row justify="center">
                    <v-card-title class="white--text title text-center py-0" style="white-space:nowrap;">
                      {{ $t(recruit.title) }}
                    </v-card-title>
                  </v-row>
                  <!--                  <v-card-text class="white--text py-0">
                                      <v-btn width=100 :to="recruit.to" rounded color="rgba(255,255,255,0.2)" class="white--text subtitle-1">GO</v-btn>
                                    </v-card-text>-->
                </v-card>
              </v-col>
            </v-row>
          </v-img>
        </v-col>
      </v-row>
      <v-spacer></v-spacer>


      <!--      <div :class="{test:true,testenter:testShow}" ref="testref">
            <v-row no-gutters class="text-center" align="start">
              <v-spacer></v-spacer>
              <v-col :cols='isMobile?12:"false"'>
                <v-card class="mb-4" flat tile color="transparent">
                  <v-card-title style="font-size: 50px;margin-top: 20%" :class='isMobile?"subtitle-1":"title font-weight-regular text-no-wrap justify-center"' v-html="$t('recruit.joinUsContent')">{{ $t('recruit.joinUsContent') }}</v-card-title>
                </v-card>
              </v-col>
              <v-spacer></v-spacer>
            </v-row>
            </div>-->

      <div :class="{test:true,testenter:testShow2}" ref="test2ref">
        <v-row no-gutters class="text-center" align="start">
          <v-spacer></v-spacer>
          <v-col :cols='isMobile?12:"false"'>
            <v-card class="mb-4" flat tile color="transparent">
              <v-card-title style="font-size: 50px;margin-top: 25%;color: rgb(192, 27, 44)" :class='isMobile?"subtitle-1":"title font-weight-regular text-no-wrap justify-center"' >事业的原点在于磨练人才与技术，</v-card-title>
            </v-card>
          </v-col>
          <v-spacer></v-spacer>
        </v-row>
      </div>

      <div :class="{test:true,testenter:testShow3}" ref="test3ref">
        <v-row no-gutters class="text-center" align="start">
          <v-spacer></v-spacer>
          <v-col :cols='isMobile?12:"false"'>
            <v-card class="mb-4" flat tile color="transparent">
              <v-card-title style="font-size: 50px;margin-top: 5%;color: rgb(192, 27, 44)" :class='isMobile?"subtitle-1":"title font-weight-regular text-no-wrap justify-center"' >利用数字化转型的力量推动客户企业的变革，</v-card-title>
            </v-card>
          </v-col>
          <v-spacer></v-spacer>
        </v-row>
      </div>

      <div :class="{test:true,testenter:testShow4}" ref="test4ref">
        <v-row no-gutters class="text-center" align="start">
          <v-spacer></v-spacer>
          <v-col :cols='isMobile?12:"false"'>
            <v-card class="mb-4" flat tile color="transparent">
              <v-card-title style="font-size: 50px;margin-top: 5%;color: rgb(192, 27, 44)" :class='isMobile?"subtitle-1":"title font-weight-regular text-no-wrap justify-center"' >我们致力于成为独一无二的合作伙伴。</v-card-title>
            </v-card>
          </v-col>
          <v-spacer></v-spacer>
        </v-row>
      </div>

      <!--      <div :class="{test:true,testenter:testShow5}" ref="test5ref">
              <v-row no-gutters class="text-center" align="start">
                <v-spacer></v-spacer>
                <v-col :cols='isMobile?12:"false"'>
                  <v-card class="mb-4" flat tile color="transparent">
                    <v-card-title style="font-size: 50px;margin-top: 5%" :class='isMobile?"subtitle-1":"title font-weight-regular text-no-wrap justify-center"' ></v-card-title>
                  </v-card>
                </v-col>
                <v-spacer></v-spacer>
              </v-row>
            </div>-->

      <div :class="{test:true,testenter:testShow6}" ref="test6ref">
        <v-row no-gutters class="text-center" align="start">
          <v-spacer></v-spacer>
          <v-col :cols='isMobile?12:"false"'>
            <v-card class="mb-4" flat tile color="transparent">
              <v-card-title style="font-size: 50px;margin-top: 10%;color: rgb(192, 27, 44)" :class='isMobile?"subtitle-1":"title font-weight-regular text-no-wrap justify-center"' >加入我们，成为变革的一部分，你是我们共同愿景的推动者。</v-card-title>
            </v-card>
          </v-col>
          <v-spacer></v-spacer>
        </v-row>
      </div>

      <div :class="{test:true,testenter:testShow7}" ref="test7ref">
        <v-row no-gutters class="text-center" align="start">
          <v-spacer></v-spacer>
          <v-col :cols='isMobile?12:"false"'>
            <v-card class="mb-4" flat tile color="transparent">
              <v-card-title style="font-size: 50px;margin-top: 5%;color: rgb(192, 27, 44)" :class='isMobile?"subtitle-1":"title font-weight-regular text-no-wrap justify-center"' >我们相信，通过创新和协作，每个人都能为行业带来积极的改变。</v-card-title>
            </v-card>
          </v-col>
          <v-spacer></v-spacer>
        </v-row>
      </div>

      <div :class="{test:true,testenter:testShow8}" ref="test8ref">
        <v-row no-gutters class="text-center" align="start">
          <v-spacer></v-spacer>
          <v-col :cols='isMobile?12:"false"'>
            <v-card class="mb-4" flat tile color="transparent">
              <v-card-title style="font-size: 50px;margin-top: 5%;color: rgb(192, 27, 44)" :class='isMobile?"subtitle-1":"title font-weight-regular text-no-wrap justify-center"' >我们鼓励每一位成员勇于探索，不断学习，</v-card-title>
            </v-card>
          </v-col>
          <v-spacer></v-spacer>
        </v-row>
      </div>

      <div :class="{test:true,testenter:testShow9}" ref="test9ref">
        <v-row no-gutters class="text-center" align="start">
          <v-spacer></v-spacer>
          <v-col :cols='isMobile?12:"false"'>
            <v-card class="mb-4" flat tile color="transparent">
              <v-card-title style="font-size: 50px;margin-top: 5%;color: rgb(192, 27, 44)" :class='isMobile?"subtitle-1":"title font-weight-regular text-no-wrap justify-center"' >与我们一同在变革的浪潮中砥砺前行。</v-card-title>
            </v-card>
          </v-col>
          <v-spacer></v-spacer>
        </v-row>
      </div>

      <div :class="{test:true,testenter:testShow10}" ref="test10ref">
        <v-row no-gutters class="text-center" align="start">
          <v-spacer></v-spacer>
          <v-col :cols='isMobile?12:"false"'>
            <v-card class="mb-4" flat tile color="transparent">
              <v-card-title style="font-size: 50px;margin-top: 5%;color: rgb(192, 27, 44)" :class='isMobile?"subtitle-1":"title font-weight-regular text-no-wrap justify-center"' >让我们携手，用智慧和热情，共同书写未来的篇章。</v-card-title>
            </v-card>
          </v-col>
          <v-spacer></v-spacer>
        </v-row>
      </div>

      <v-row justify="center" align="center" class="py-12">
        <v-btn to="/recruit-2019" color="#0F1D2D" width=300 height=50 x-large class=" white--text" elevation=24 tile>{{ $t('service.joinIn') }}</v-btn>
      </v-row>



      <!--      <v-row>
                <v-spacer></v-spacer>
                <v-img :width='isMobile?"":"200"' src="../assets/recruit/1-1.jpg">
                  <v-row align="center" class="white&#45;&#45;text fill-height text-center">
                      <v-spacer></v-spacer>
                      <v-col>
      &lt;!&ndash;                  <v-card flat tile color="transparent" >
                          <v-row justify="center">
                          <v-card-title :class='(isMobile?"title ":"display-2 ")+"white&#45;&#45;text text-center"' style="white-space:nowrap;">
                            ON CHALLENGE NO LIFE
                          </v-card-title>
                          </v-row>
                          <v-divider color="white"></v-divider>
                          <v-card-actions>
                            <v-row justify="center">
                            <v-btn text :class='(isMobile?"title ":"display-1 ")+"white&#45;&#45;text"' style="white-space:nowrap;" to="/recruit-2019">
                                {{ $t('recruit.mainPage.title1') }}
                            </v-btn>
                            </v-row>
                          </v-card-actions>
                        </v-card>&ndash;&gt;
                      </v-col>
                      <v-spacer></v-spacer>
                    </v-row>
                </v-img>
                <v-spacer></v-spacer>
              </v-row>
            <v-row>
                <v-card flat color="transparent" class="mx-auto mt-2 mb-6 text-center">
                  <v-card-title class="font-weight-regular mb-2">{{ $t('recruit.mainPage.title2') }}</v-card-title>
                </v-card>
            </v-row>
            &lt;!&ndash; 非手机端 &ndash;&gt;
            <v-row no-gutters justify="center" class="d-none d-sm-flex">
              <v-spacer></v-spacer>
              <v-col v-for="(recruit,index) in recruits" :key="recruit.title" class="mx-0 px-0">
                <v-avatar tile size=220 class="mx-0">
                  <v-img  :src="recruit.imageUrl" :position="index===3?'top left':'center center'">
                    <v-row align="center" class="white&#45;&#45;text fill-height text-center px-0 mx-0">
                      <v-col>
                        <v-card flat tile color="transparent" >
                          <v-row justify="center">
                          <v-card-title class="white&#45;&#45;text subtitle-1 text-center py-0" style="white-space:nowrap;">
                            {{ $t(recruit.title) }}
                          </v-card-title>
                          </v-row>
                          <v-card-text class="white&#45;&#45;text py-0">
                              <v-btn :to="recruit.to" small fab color="rgba(255,255,255,0.2)" class="white&#45;&#45;text subtitle-1">GO</v-btn>
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-img>
                </v-avatar>
              </v-col>
              <v-spacer></v-spacer>
            </v-row>
            &lt;!&ndash; 手机端 &ndash;&gt;
            <v-row justify="center" class="d-flex d-sm-none">
              <v-col v-for="(recruit,index) in recruits" :key="recruit.title" class="mx-0 px-0 py-1">
                  <v-img height=200 :src="recruit.imageUrl" :position="index===3?'top left':'center center'">
                    <v-row align="center" class="white&#45;&#45;text fill-height text-center px-0 mx-0">
                      <v-col>
                        <v-card flat tile color="transparent" >
                          <v-row justify="center">
                          <v-card-title class="white&#45;&#45;text title text-center py-0" style="white-space:nowrap;">
                            {{ $t(recruit.title) }}
                          </v-card-title>
                          </v-row>
                          <v-card-text class="white&#45;&#45;text py-0">
                              <v-btn width=100 :to="recruit.to" rounded color="rgba(255,255,255,0.2)" class="white&#45;&#45;text subtitle-1">GO</v-btn>
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-img>
              </v-col>
            </v-row>-->



    </v-container>
    <tci-contact-footer color="white"></tci-contact-footer>
  </div>
</template>

<script>
import TciContactFooter from "@/components/TciContactFooter.vue";
// import TciTitle from "@/components/TciTitle.vue";

export default {
  name: "CompanyService",
  components: {
    // "tci-title": TciTitle,
    "tci-contact-footer": TciContactFooter
  },
  data: () => ({
    recruits: [
      /*{
        "imageUrl": require('../assets/recruit/2-1.jpg'),
        "title": "recruit.mainPage.recruit_manager",
        "to": "/recruit-project-manager"
      },
      {
        "imageUrl": require('../assets/recruit/2-2.jpg'),
        "title": "recruit.mainPage.recruit_dev",
        "to": "/recruit-bdeveloper"
      },
      {
        "imageUrl": require('../assets/recruit/2-3.jpg'),
        "title": "recruit.mainPage.recruit_trans",
        "to": "/recruit-translate"
      },
      {
        "imageUrl": require('../assets/recruit/2-4.jpg'),
        "title": "recruit.mainPage.recruit_sap",
        "to": "/recruit-bserver-engineer"
      }*/

      {
        "imageUrl": require('../assets/recruit/1-1.jpg')
      },
      {
        "imageUrl": require('../assets/recruit/bg1.jpg')
      },
      {
        "imageUrl": require('../assets/recruit/bg2.jpg')
      },
      {
        "imageUrl": require('../assets/recruit/bg3.jpg')
      },


    ],
    isMobile: false,
    testShow: false,
    testShow2: false,
    testShow3: false,
    testShow4: false,
    testShow5: false,
    testShow6: false,
    testShow7: false,
    testShow8: false,
    testShow9: false,
    testShow10: false,
  }),

  mounted() {
    this.isMobile = this.$vuetify.breakpoint.xs;
    window.addEventListener("scroll", this.handleScroll);
  },

  methods: {
    handleScroll() {
      this.currentScroll = window.pageYOffset //表示当前滚动的位置
      /*      if (this.currentScroll >= this.$refs.testref.offsetTop - 1000) { //当前滚动位置到达testref的时候，显示div（100作为调整用）
              this.testShow = true;
            }*/
      if (this.currentScroll >= this.$refs.test2ref.offsetTop - 1000) {
        this.testShow2 = true;
      }
      if (this.currentScroll >= this.$refs.test3ref.offsetTop - 800) {
        this.testShow3 = true;
      }
      if (this.currentScroll >= this.$refs.test4ref.offsetTop - 800) {
        this.testShow4 = true;
      }
      /*      if (this.currentScroll >= this.$refs.test5ref.offsetTop - 700) {
              this.testShow5 = true;
            }*/
      if (this.currentScroll >= this.$refs.test6ref.offsetTop - 800) {
        this.testShow6 = true;
      }
      if (this.currentScroll >= this.$refs.test7ref.offsetTop - 800) {
        this.testShow7 = true;
      }
      if (this.currentScroll >= this.$refs.test8ref.offsetTop - 800) {
        this.testShow8 = true;
      }
      if (this.currentScroll >= this.$refs.test9ref.offsetTop - 800) {
        this.testShow9 = true;
      }
      if (this.currentScroll >= this.$refs.test10ref.offsetTop - 800) {
        this.testShow10 = true;
      }

    },
  }

}




</script>

<style scoped>
.v-application .title {
  font-size: 1.5rem !important;
  font-weight: 500;
  line-height: 0.8rem;
  letter-spacing: 0.0125em !important;
  font-family: "Microsoft YaHei", Roboto, "sans-serif" !important;
}
.testenter{
  transform: translateY(0%)!important;
  opacity: 1!important;
  transition: all .5s ease;
}

.test{
  transform: translateY(100%);
  opacity: 0;
}
</style>
